import { XMLParser } from "fast-xml-parser";
import dayjs from "dayjs";

export interface NfeProduto {
  codigo: string;
  produto: string;
  quantidade: number;
  valorUnitario: number;
  valorTotal: number;
}

export interface NFe {
  nf: string;
  fornecedor: string;
  dataEmissao: Date;
  produtos: NfeProduto[];
}

const MAPPING = {
  nf: "nfeProc/NFe/infNFe/ide/nNF",
  dataEmissao: "nfeProc/NFe/infNFe/ide/dhEmi",
  fornecedor: "nfeProc/NFe/infNFe/emit/xNome"
};

export async function readNFe(file: File) {
  const dataXml = await file.text();
  return parseNFe(dataXml);
}

function getPath(obj: any, path: string): any {
  return path.split("/").reduce((acc, key) => {
    if (acc == null) return undefined;
    if (key.endsWith("[]")) {
      return acc[key.slice(0, -2)];
    }
    return acc[key];
  }, obj);
}

function toNumber(value: any): number {
  if (value == null) return 0;
  const n = Number(String(value).replace(",", "."));
  return Number.isNaN(n) ? 0 : n;
}

function parseNFe(xml: string): NFe {
  const parser = new XMLParser({
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    parseTagValue: true,
    trimValues: true,
  });

  const json = parser.parse(xml);

  const dets = getPath(json, "nfeProc/NFe/infNFe/det[]") ?? [];
  const detArray = Array.isArray(dets) ? dets : [dets];

  const produtos: NfeProduto[] = detArray.map((det: any) => ({
    codigo: String(getPath(det, "prod/cProd") ?? ""),
    produto: String(getPath(det, "prod/xProd") ?? ""),
    quantidade: toNumber(getPath(det, "prod/qCom")),
    valorUnitario: toNumber(getPath(det, "prod/vUnCom")),
    valorTotal: toNumber(getPath(det, "prod/vProd")),
  }));

  return {
    nf: String(getPath(json, MAPPING.nf) ?? ""),
    fornecedor: String(getPath(json, MAPPING.fornecedor) ?? ""),
    dataEmissao: dayjs(String(getPath(json, MAPPING.dataEmissao) ?? "")).utc().toDate(),
    produtos,
  };
}